
const digest = 'aa42769f6ee2c6d047e0a91659b4981114a58ef954bae795c4ca5f23d48c75b5';
const classes = {"wrapper":"_wrapper_1f2od_1","checkbox":"_checkbox_1f2od_9","active":"_active_1f2od_19","title":"_title_1f2od_24","childrenWrapper":"_childrenWrapper_1f2od_31","disabled":"_disabled_1f2od_35"};
const css = `._wrapper_1f2od_1 {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  height: fit-content;
  font-family: Poppins, sans-serif;
}

._checkbox_1f2od_9 {
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
  background: url("/dist/patientV3/icons/checkbox-default.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}

._active_1f2od_19 {
  background: url("/dist/patientV3/icons/checkbox-checked.svg") no-repeat center;
  background-size: contain;
}

._title_1f2od_24 {
  font-size: 14px;
  font-weight: 600;
  margin-left: 7.5px;
  color: #3c3f9c;
}

._childrenWrapper_1f2od_31 {
  margin-left: 7.5px;
}

._disabled_1f2od_35 {
  cursor: not-allowed;
}
._disabled_1f2od_35 ._checkbox_1f2od_9 {
  opacity: 0.8;
  cursor: not-allowed;
}
._disabled_1f2od_35 ._title_1f2od_24 {
  color: #939393;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  